<template>
  <div id="Portfolio" class="c-portfolio">
    <router-view></router-view>

    <div id="TableOfContents" class="c-gallery" v-if="this.$route.name == 'Portfolio'">
      <div class="c-block">
        <div class="c-piece__summary">
          <h3 class="h-squash">Generative AI, Machine Learning and Data Analysis (oh my!)</h3>
          <h5>
            Interested in my current projects?
            <a href="https://www.linkedin.com/in/michaelcohnmoreau/" target="_blank">
              Please reach out to me directly.
            </a>
          </h5>
          <a href="https://www.linkedin.com/in/michaelcohnmoreau/" target="_blank">
            <img src="images/portfolio/capacity_planning/placeholder.png" />
          </a>
        </div>
      </div>

      <div class="o-layout c-block">
        <div class="o-layout__item">
          <router-link to="/portfolio/MedPhysics">
            <div class="c-piece__summary">
              <h3>End-to-End Product Design for Testing a Medical Device</h3>
            </div>
            <img class="o-link" src="images/portfolio/rx/water_tank_cropped.jpg" />
          </router-link>
        </div>
      </div>

      <div class="o-layout c-block">
        <div class="o-layout__item">
          <router-link to="/portfolio/Evaluation">
            <div class="c-piece__summary">
              <h3>Redesigning Treatment Planning Software for Clinicians</h3>
            </div>
            <img class="o-link" src="images/portfolio/rx/inuse_small.jpg" />
          </router-link>
        </div>
      </div>

      <div class="o-layout c-block">
        <div class="o-layout__item">
          <router-link to="/portfolio/DataJourney">
            <div class="c-piece__summary">
              <h3>Explaining Product Value through Handmade Illustrations</h3>
            </div>
            <img class="o-link" src="images/portfolio/data_journey/Data_Journey.jpeg" />
          </router-link>
        </div>
      </div>
    </div>

    <div class="c-bottomlinks c-piece" v-if="this.$route.name !== 'Portfolio'">
      <router-link to="/portfolio/MedPhysics"> Medical Physics Workspace </router-link>
      <router-link to="/portfolio/Evaluation"> Treatment Planning & Evaluation </router-link>
      <router-link to="/portfolio/DataJourney"> Diagramming the Data Journey </router-link>
      <router-link to="/portfolio"> All </router-link>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@use '../assets/scss/_mixins.scss';

/* Intro Page - Show All Case Studies with Links */
.c-gallery {
  img {
    max-height: 280px;
    width: 100%;
    object-fit: cover;
    object-position: 100% 50%;

    @include mixins.pop;

    &.o-link {
      &:hover {
        @include mixins.drop;
      }
    }
  }
}

/* Links that Appear at the Bottom of Each Case Study */
.c-bottomlinks {
  padding-top: 1.6rem;
  text-align: center;

  a {
    color: mixins.$color-light-yellow-gray;
    margin: 0 mixins.$padding-small;
    border: 0;

    &:hover {
      color: mixins.$color-medium-yellow-gray;
      border-bottom: 1px solid mixins.$color-light-bright-yellow;
    }
  }

  a.router-link-exact-active {
    color: mixins.$color-near-black;
  }
}

/* Styling on a Case Study */

.c-casestudy {
  margin-bottom: mixins.$padding-regular;

  .c-casestudy-section {
    margin-bottom: mixins.$padding-large;
  }
}

.c-kpi {
  padding: 0 mixins.$padding-regular;
}

.c-kpi+.c-kpi {
  border-left: 1px solid mixins.$color-bright-yellow;
}
</style>
